var exports = {
  "kL": "xfb577c5e--4abf9e--container",
  "pq": "xfb577c5e--4abf9e--info",
  "Kk": "xfb577c5e--4abf9e--icon",
};

module.exports = exports;
